import React from 'react';
import { Grid } from '@mui/material';
import Card from './Card';
import Remittance from 'images/remessa.png';
import Inputs from 'images/insumos.png';
import { useDependencyInjection } from 'hooks/useDependencyInjection';

function TypePurchase() {
  const { history } = useDependencyInjection();

  return (
    <Grid
      container
      p="1rem 3rem 1rem 3.75rem"
      display="flex"
      justifyContent="center"
      spacing={2}
    >
      <Grid item>
        <Card
          image={Inputs}
          widthImage={335}
          title="Insumos"
          description="Refere-se à aquisição de matérias-primas, materiais ou componentes necessários para a produção da empresa."
          textButton="Nova compra"
          onClick={() => history.push({
            pathname: '/purchase/',
            state: {
              productType: 'input',
            },
          })}
        />
      </Grid>
      <Grid item>
        <Card
          image={Remittance}
          title="Remessa de Pós-larva"
          description="Refere-se à aquisição de matérias-primas, materiais ou componentes necessários para a produção da empresa."
          textButton="Nova remessa"
          onClick={() => history.push({
            pathname: '/purchase/',
            state: {
              productType: 'remittance',
            },
          })}
        />
      </Grid>
    </Grid>
  );
}

export default TypePurchase;
